import template from './date_picker.html.slim';

angular.module('wbComponents').directive('wbDatePicker', function() {
  return {
    replace: true,
    restrict: 'E',
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      date: '=',
      startDate: '=',
      endDate: '=',
      pillId: '@',
      pillText: '@',
      pillRowName: '@', // match with the row name you're inserting into for radio button effect
      dateRangeOrientation: '@'
    }, // expects 'vertical' or an empty string
    templateUrl: template,

    controller() {
      this.dateSelected = date => {
        this.date = date;
        return this.visible = false;
      };

      this.isSelected = date => {
        return moment(date).isSame(this.date, 'd');
      };

      return this;
    },

    link($scope, $el, $attrs) {
      $('html').on('click', function(e) {
        if ($.contains($el[0], e.target)) { return; }
        $scope.ctrl.visible = false;
      });

      return $el.on('click', e => e.stopImmediatePropagation());
    }
  };
});
